import { getLocalDatabaseVersion } from './get-local-database-version';
import { setLocalDatabaseVersion } from './set-local-database-version';

export { getLocalDatabaseVersion, setLocalDatabaseVersion };
